import React from 'react'
import {Link} from "react-router-dom"

export default function Contact() {
  return (
    <div>
      
      
      <body background={require('./images/a2.jpg')} > 
      
      <table align="center" width="900">
          
          <tr>
      
            <td width="200" align="center"> <Link to="/Home"> <h3><font face="Trebuchet" color="white" size="4">Home</font></h3></Link></td>
            <td width="200" align="center"> <Link to="/Products"><h3><font face="Trebuchet" color="white" size="4">Products</font></h3></Link></td>
           
            <td width="200" align="center"> <Link to="/Clients"><h3><font face="Trebuchet" color="white" size="4">Clients</font></h3></Link></td> 
            
            <td width="200" align="center"> <Link to="/Contact"><h3><font face="Trebuchet" color="white" size="4">Contact us</font></h3></Link></td>  
      
          </tr>
      
          </table>

          <table  align="center">

<tr  align="center">
 
 <td align="center">
<font face="Trebuchet" color="white" size="4">  </font><br/>
                   <font face="Trebuchet" color="white" size="4"> Your Business Name</font><br/>  
                     <font face="Trebuchet" color="white" size="4"> Street #, Street Name,Town/City <br/>Postal/Zip Code . Country. <br/>
                          Telephone ;&nbsp;&nbsp;
                            Email address </font> <br/>


                            </td>
</tr>




</table>


<table  background={require('./images/paasi.jpg')} align="center"  border="0"  cellpadding="0" bgcolor='#FFFFFF'  width="400" height="400">

                     
                      
<tr >
<td align="left" width="150"><font face="Georgia" color="black" size="3">&nbsp;&nbsp;   Visitor name </font></td>

<td align="left"><input type="text" name="name" size="30"  id="name"/></td>
</tr>

<tr>
<td  align="left" width="150"><font face="Georgia" color="black" size="3">&nbsp;&nbsp;Company name</font></td>
<td align="left"><input type="text" name="company" size="30"  id="company"/></td>
</tr>

<tr>
<td align="left" width="150"><font face="Georgia" color="black" size="3">&nbsp;&nbsp;Country</font></td>
<td align="left"><input type="text" name="country" size="20"  id="country" /></td>
</tr>


<tr>
<td align="left" width="150" ><font face="Georgia" color="black" size="3">&nbsp;&nbsp;Email</font></td>
<td align="left"><input type="text" name="email" size="30"  id="email"/ ></td>
</tr>


<tr>

<td align="left" width="150" ><font face="Georgia" color="black" size="3">&nbsp;&nbsp;Message </font></td>
<td align="left" ><textarea cols="25" rows="10" name="message" id="msg"></textarea></td>
   
</tr>

</table>



<table background={require('./images/a2.jpg')} align="center"  border="0"  cellpadding="0" bgcolor='#FFFFFF'  width="100"  >

                                 <tr>
                                    
                                    <td>

                                    &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input   align="center"  type="button"  onclick="sendemail()"value="Send      "/>
                                   
                                   </td>
                                   
                                   <td width="60"></td>

                                   <td>
                                    &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;<input    align="center"  type="button" value="Cancel"  onclick="clearbox()"/>

                                  </td>

                                  </tr>

 </table>

 <h4 align="center"> <font size="3" color="white" face="Times New Roman">Developed & Updated on 2024-02-11 by Priyantha Wanninayake  Email : kstpromotions@gmail.com  </font></h4>
 

      </body>

      </div>
  )
}